import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const SkeletonContext = createContext(undefined);
export const useSkeleton = () => {
    const context = useContext(SkeletonContext);
    if (!context) {
        throw new Error('useSkeleton must be used within a SkeletonProvider');
    }
    return context;
};
export const SkeletonProvider = ({ children, isLoading = false }) => {
    return (_jsx(SkeletonContext.Provider, { value: { isLoading }, children: children }));
};
//# sourceMappingURL=skeleton-provider.js.map